import React from 'react';
import loadable from '@loadable/component';
import { loadGraphQLData } from '../page';

const PDP = loadable(() => import('./components-v2'));

export default {
    component: PDP,
    loadData: loadGraphQLData,
};
